// 客服3菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/simpleIndex',
    title: '系统首页',
  },
  {
    icon: 'el-icon-user',
    index: '/userList',
    title: '用户管理',
  },
  {
    icon: 'el-icon-s-order',
    index: '3',
    title: '订单管理',
    subs: [
      {
        index: '/orderList',
        title: '订单管理',
      },
      {
        index: '/settlementOrderList',
        title: '结算列表',
      },
    ]
  },
  {
    icon: 'el-icon-goods',
    index: '2',
    title: '商品管理',
    subs: [
      {
        index: '/goodsList',
        title: '商品列表',
      },
      {
        index: '/indexGoodsList',
        title: '首页商品管理',
      },
      {
        index: '/cityGoods',
        title: '一县一特',
      },
      {
        index: '/goodsAuditList',
        title: '商品审核',
      },
      {
        index: '/classify',
        title: '分类列表',
      },
    ],
  },
  {
    icon: 'el-icon-lx-copy',
    index: '7',
    title: '运营管理',
    subs: [
      {
        index: '/shopList',
        title: '店铺管理',
      },
      {
        index: '/shopAudit',
        title: '店铺审核',
      },
      {
        index: '/shopWealthRecordList',
        title: '店铺流水',
      },
    ],
  },
  {
    icon: 'el-icon-lx-cascades',
    index: '11',
    title: '系统管理',
    subs: [
      {
        index: '/shopPlatformManager',
        title: '后台店铺用户管理',
      },
    ]
  }


]

export default menus
